import { render, staticRenderFns } from "./test-portal-banner.vue?vue&type=template&id=3f7de8a4&scoped=true&"
import script from "./test-portal-banner.vue?vue&type=script&lang=js&"
export * from "./test-portal-banner.vue?vue&type=script&lang=js&"
import style0 from "./test-portal-banner.vue?vue&type=style&index=0&id=3f7de8a4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f7de8a4",
  null
  
)

component.options.__file = "test-portal-banner.vue"
export default component.exports